import { connect } from 'react-redux';
import { compose } from 'redux';
import { injectIntl } from 'react-intl';

// Components
import MileageSelector from './MileageSelector';

// Selectors
import {
  getPackageMileages,
  getServicePoint as getServicePointFromState,
  getAllServicePoints,
  getDisplayMonths,
  getPackageMonths
} from 'store/reducers/packages/selectors';
import { getShowMileage } from 'store/reducers/dealerSettings/selectors';
import {
  getServicePoint,
  getServicesCount
} from 'store/reducers/appointment/selectors';
import { getIsQuoteAppt } from 'store/reducers/quoteAppt/selectors';
// Actions
import {
  getPackages,
  clearPackages,
  setExactMileageFlag
} from 'store/reducers/packages/actions';
import {
  setApptServicePoint,
  clearApptServices
} from 'store/reducers/appointment/actions';
import { gtmUserEvent } from 'store/reducers/gtm/actions';

// Utils
import { undefinedToTrue } from 'utils/varValidation';

const mapStateToProps = state => {
  return {
    packageMileages: getPackageMileages(state),
    packageMonths: getPackageMonths(state),
    servicePointFromState: getServicePointFromState(state),
    showMileage: undefinedToTrue(getShowMileage(state)),
    selectedPackage: getServicePoint(state),
    hasSelectedServices: getServicesCount(state) > 0,
    allServicePoints: getAllServicePoints(state),
    displayMonths: getDisplayMonths(state),
    isQuoteAppt: getIsQuoteAppt(state)
  };
};

export default compose(
  injectIntl,
  connect(
    mapStateToProps,
    {
      getPackages,
      clearPackages,
      clearApptServices,
      gtmUserEvent,
      setApptServicePoint,
      setExactMileageFlag
    }
  )
)(MileageSelector);



// WEBPACK FOOTER //
// ./src/components/molecules/MileageSelector/MileageSelectorContainer.js